// extracted by mini-css-extract-plugin
export default {"link":"style_link__DYZjy","active":"style_active__Oqyx8"};